<template>
  <transition name="el-zoom-in-top" @after-leave="$emit('dodestroy')">
    <div
      v-show="visible"
      id="kye-date-range-picker2_panel"
      class="el-picker-panel el-date-range-picker el-popper kye-date-ranage-picker2_panel"
      :class="[{
        'has-sidebar': $slots.sidebar || shortcuts,
      }, popperClass]">
      <div class="kye-date-picker2-flex">
        <slot name="sidebar"></slot>
        <ShortcutsWrap
          :type="type"
          v-if="showShortcuts"
          :shortcuts="shortcuts"
          :handleShortcutClick="handleShortcutClick"
          currentView="date"
          :showMonthSelect="showMonthSelect"
          :changeShortcutMonth="changeShortcutMonth"
          :handleShortcutMonthClick="handleShortcutMonthClick"
          :disabledMonth="disabledMonth"
        ></ShortcutsWrap>
        <div class="el-picker-panel__body-wrapper">
          <div class="el-picker-panel__body" :class="{'m-l-12': showShortcuts}">
            <!-- 左边 -->
            <div class="el-picker-panel__content el-date-range-picker__content is-left">
              <div class="el-date-range-picker__header kye-date-picker2-header-wrap bt-none" :class="[showLocator ? 'flex-sb' : 'flex-center']">
                <div class="left-wrap">
                  <button
                    type="button"
                    @click="leftPrevYear"
                    class="el-picker-panel__icon-btn el-icon-d-arrow-left"></button>
                  <button
                    type="button"
                    @click="leftPrevMonth"
                    class="el-picker-panel__icon-btn el-icon-arrow-left"></button>
                  <YearSelect
                    class="m-r-8"
                    @pick="handleYearPick($event, 'leftDate')"
                    :default-value="defaultValue ? new Date(defaultValue) : null"
                    :date="leftDate"
                    :endDate="rightDate"
                  >
                  </YearSelect>
                  <MonthSelect
                    @pick="handleMonthPick($event, 'leftDate')"
                    :default-value="defaultValue ? new Date(defaultValue) : null"
                    :date="leftDate"
                    :endDate="rightDate"
                  >
                  </MonthSelect>
                  <button
                    type="button"
                    @click="leftNextMonth"
                    :disabled="!enableMonthArrow"
                    :class="{ 'is-disabled': !enableMonthArrow }"
                    class="el-picker-panel__icon-btn el-icon-arrow-right">
                  </button>
                  <button
                    type="button"
                    @click="leftNextYear"
                    :disabled="!enableYearArrow"
                    :class="{ 'is-disabled': !enableYearArrow }"
                    class="el-picker-panel__icon-btn el-icon-d-arrow-right"></button>
                </div>
                <kye-button
                  v-if="showLocator"
                  @click="locatorToToday(true)"
                  class="locator-today"
                  type="text">
                  定位到今天
                </kye-button>
              </div>
              <div class="kye-date-picker2-date-table-wrap">
                <date-table
                  selection-mode="range"
                  :date="leftDate"
                  :showLunar="showLunar"
                  :default-value="defaultValue"
                  :min-date="minDate"
                  :max-date="maxDate"
                  :range-state="rangeState"
                  :disabled-date="disabledDate"
                  :cell-class-name="cellClassName"
                  @changerange="handleChangeRange"
                  :first-day-of-week="firstDayOfWeek"
                  @pick="handleRangePick"
                  >
                </date-table>
              </div>
            </div>
            <!-- 右边 -->
            <div class="el-picker-panel__content el-date-range-picker__content is-right">
              <div class="el-date-range-picker__header kye-date-picker2-header-wrap bt-none" :class="[showLocator ? 'flex-sb' : 'flex-center']">
                <div class="left-wrap">
                  <button
                    type="button"
                    @click="rightPrevYear"
                    :disabled="!enableYearArrow"
                    :class="{ 'is-disabled': !enableYearArrow }"
                    class="el-picker-panel__icon-btn el-icon-d-arrow-left"></button>
                  <button
                    type="button"
                    @click="rightPrevMonth"
                    :disabled="!enableMonthArrow"
                    :class="{ 'is-disabled': !enableMonthArrow }"
                    class="el-picker-panel__icon-btn el-icon-arrow-left"></button>

                  <YearSelect
                    class="m-r-8"
                    @pick="handleYearPick($event, 'rightDate')"
                    :default-value="defaultValue ? new Date(defaultValue) : null"
                    :date="rightDate"
                    :startDate="leftDate"
                  >
                  </YearSelect>
                  <MonthSelect
                    @pick="handleMonthPick($event, 'rightDate')"
                    :default-value="defaultValue ? new Date(defaultValue) : null"
                    :date="rightDate"
                    :startDate="leftDate"
                  >
                  </MonthSelect>
                  <button
                    type="button"
                    @click="rightNextMonth"
                    class="el-picker-panel__icon-btn el-icon-arrow-right"></button>
                  <button
                    type="button"
                    @click="rightNextYear"
                    class="el-picker-panel__icon-btn el-icon-d-arrow-right"></button>
                  <!-- <div>{{ rightLabel }}</div> -->
                </div>
                <kye-button
                  v-if="showLocator"
                  @click="locatorToToday(false)"
                  class="locator-today"
                  type="text">
                  定位到今天
                </kye-button>
              </div>
              <div class="kye-date-picker2-date-table-wrap">
                <date-table
                  selection-mode="range"
                  :date="rightDate"
                  :showLunar="showLunar"
                  :default-value="defaultValue"
                  :min-date="minDate"
                  :max-date="maxDate"
                  :range-state="rangeState"
                  :disabled-date="disabledDate"
                  :cell-class-name="cellClassName"
                  @changerange="handleChangeRange"
                  :first-day-of-week="firstDayOfWeek"
                  @pick="handleRangePick"
                  >
                </date-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script type="text/babel">
  import moment from 'moment'
  import {
    formatDate,
    parseDate,
    isDate,
    modifyDate,
    modifyTime,
    modifyWithTimeString,
    prevYear,
    nextYear,
    prevMonth,
    nextMonth,
    nextDate,
    extractDateFormat,
    extractTimeFormat,
    changeYearMonthAndClampDate,
    modifyStartTime,
    modifyEndTime
  } from '../utils'
  import Clickoutside from 'element-ui/lib/utils/clickoutside'
  import Locale from 'element-ui/lib/mixins/locale'
  import DateTable from '../basic/date-table'
  import ShortcutsWrap from '../basic/shortcuts-wrap'
  import YearSelect from '../basic/year-select'
  import MonthSelect from '../basic/month-select'

  const calcDefaultValue = (defaultValue) => {
    if (Array.isArray(defaultValue)) {
      return [new Date(defaultValue[0]), new Date(defaultValue[1])]
    } else if (defaultValue) {
      return [new Date(defaultValue), nextDate(new Date(defaultValue), 1)]
    } else {
      return [new Date(), nextDate(new Date(), 1)]
    }
  }

  export default {
    mixins: [Locale],

    directives: { Clickoutside },

    computed: {
      btnDisabled() {
        return !(this.minDate && this.maxDate && !this.selecting && this.isValidValue([this.minDate, this.maxDate]))
      },

      leftLabel() {
        return this.leftDate.getFullYear() + ' ' + this.t('el.datepicker.year') + ' ' + this.t(`el.datepicker.month${this.leftDate.getMonth() + 1}`)
      },

      rightLabel() {
        return this.rightDate.getFullYear() + ' ' + this.t('el.datepicker.year') + ' ' + this.t(`el.datepicker.month${this.rightDate.getMonth() + 1}`)
      },

      leftYear() {
        return this.leftDate.getFullYear()
      },

      leftMonth() {
        return this.leftDate.getMonth()
      },

      leftMonthDate() {
        return this.leftDate.getDate()
      },

      rightYear() {
        return this.rightDate.getFullYear()
      },

      rightMonth() {
        return this.rightDate.getMonth()
      },

      rightMonthDate() {
        return this.rightDate.getDate()
      },

      timeFormat() {
        if (this.format) {
          return extractTimeFormat(this.format)
        } else {
          return 'HH:mm:ss'
        }
      },

      dateFormat() {
        if (this.format) {
          return extractDateFormat(this.format)
        } else {
          return 'yyyy-MM-dd'
        }
      },

      enableMonthArrow() {
        // const nextMonth = (this.leftMonth + 1) % 12
        // const yearOffset = this.leftMonth + 1 >= 12 ? 1 : 0
        // return this.unlinkPanels && new Date(this.leftYear + yearOffset, nextMonth) < new Date(this.rightYear, this.rightMonth)
        return true
      },

      enableYearArrow() {
        // return this.unlinkPanels && this.rightYear * 12 + this.rightMonth - (this.leftYear * 12 + this.leftMonth + 1) >= 12
        return true
      },
    },

    data() {
      return {
        popperClass: '',
        value: [],
        defaultValue: null,
        defaultTime: null,
        minDate: '',
        maxDate: '',
        leftDate: new Date(),
        rightDate: nextMonth(new Date()),
        rangeState: {
          endDate: null,
          selecting: false,
          row: null,
          column: null
        },
        shortcuts: [],
        visible: '',
        disabledDate: '',
        disabledMonth: '', // 禁用快捷面板月份callback
        cellClassName: '',
        firstDayOfWeek: 7,
        minTimePickerVisible: false,
        maxTimePickerVisible: false,
        format: '',
        arrowControl: false,
        unlinkPanels: false,
        dateUserInput: {
          min: null,
          max: null
        },
        timeUserInput: {
          min: null,
          max: null
        },
        showShortcuts: true,
        showLocator: true,
        showMonthSelect: false,
        activeInputIndex: 0,
        singleValue: false,
        isPanelSelectd: false,
        type: 'daterange',
      }
    },

    watch: {
      minDate(val) {
        this.dateUserInput.min = null
        this.timeUserInput.min = null
        this.$nextTick(() => {
          if (this.$refs.maxTimePicker && this.maxDate && this.maxDate < this.minDate) {
            const format = 'HH:mm:ss'
            this.$refs.maxTimePicker.selectableRange = [
              [
                parseDate(formatDate(this.minDate, format), format),
                parseDate('23:59:59', format)
              ]
            ]
          }
        })
        if (val && this.$refs.minTimePicker) {
          this.$refs.minTimePicker.date = val
          this.$refs.minTimePicker.value = val
        }
      },

      maxDate(val) {
        this.dateUserInput.max = null
        this.timeUserInput.max = null
        if (val && this.$refs.maxTimePicker) {
          this.$refs.maxTimePicker.date = val
          this.$refs.maxTimePicker.value = val
        }
      },

      minTimePickerVisible(val) {
        if (val) {
          this.$nextTick(() => {
            this.$refs.minTimePicker.date = this.minDate
            this.$refs.minTimePicker.value = this.minDate
            this.$refs.minTimePicker.adjustSpinners()
          })
        }
      },

      maxTimePickerVisible(val) {
        if (val) {
          this.$nextTick(() => {
            this.$refs.maxTimePicker.date = this.maxDate
            this.$refs.maxTimePicker.value = this.maxDate
            this.$refs.maxTimePicker.adjustSpinners()
          })
        }
      },

      value(newVal) {
        if (!newVal) {
          this.minDate = null
          this.maxDate = null
        } else if (Array.isArray(newVal)) {
          this.minDate = isDate(newVal[0]) ? new Date(newVal[0]) : null
          this.maxDate = isDate(newVal[1]) ? new Date(newVal[1]) : null
          if (this.minDate) {
            this.leftDate = this.minDate
            if (this.unlinkPanels && this.maxDate) {
              const minDateYear = this.minDate.getFullYear()
              const minDateMonth = this.minDate.getMonth()
              const maxDateYear = this.maxDate.getFullYear()
              const maxDateMonth = this.maxDate.getMonth()
              this.rightDate = minDateYear === maxDateYear && minDateMonth === maxDateMonth
                ? nextMonth(this.maxDate)
                : this.maxDate
            } else {
              if (!this.maxDate || moment(this.maxDate).isSame(moment(this.leftDate), 'month')) {
                this.rightDate = nextMonth(this.leftDate)
              } else {
                this.rightDate = this.maxDate
              }
            }
          } else {
            this.leftDate = calcDefaultValue(this.defaultValue)[0]
            this.rightDate = nextMonth(this.leftDate)
          }
          // 这里是输入之后按enter的逻辑，单边、双边
          this.singleValue === false && this.handleInputEnterEvent(newVal)
        }
      },
      defaultValue(val) {
        if (!Array.isArray(this.value)) {
          const [left, right] = calcDefaultValue(val)
          this.leftDate = left
          this.rightDate = val && val[1] && this.unlinkPanels
            ? right
            : nextMonth(this.leftDate)
        }
      },
      visible() {
        if (this.singleValue) {
          this.isPanelSelectd = false
          const left = this.singleValue && this.minDate && !this.maxDate && this.activeInputIndex === 1
          const right = this.singleValue && this.maxDate && !this.minDate && this.activeInputIndex === 0
          if (left || right) {
            this.rangeState.selecting = true
            if (right) {
              this.minDate = this.maxDate
              this.maxDate = null // 为了date-table 在下次move移动时处理对应的BUG
            }
          } else {
            this.rangeState.selecting = false
          }
        }
      }
    },

    methods: {
      handleInputEnterEvent (value) {
        if (Array.isArray(value)) {
          const [min, max] = value
          const minDate = isDate(min) ? new Date(min) : null
          const maxDate = isDate(max) ? new Date(max) : null
          if ((min && !max) || (!min && max)) {
            this.rangeState.selecting = true
          }
          if (min) {
            this.leftDate = minDate
          } else {
            if (max) {
              this.leftDate = prevMonth(maxDate)
              this.rightDate = maxDate
              this.minDate = maxDate
              this.maxDate = null // 为了date-table 在下次move移动时处理对应的BUG
            }
          }
        }
      },
      handleClear() {
        this.minDate = null
        this.maxDate = null
        this.leftDate = calcDefaultValue(this.defaultValue)[0]
        this.rightDate = nextMonth(this.leftDate)
        this.$emit('pick', null)
      },

      handleChangeRange(val) {
        this.minDate = val.minDate
        this.maxDate = val.maxDate
        this.rangeState = val.rangeState
        this.$emit('handleChangeRange', val)
      },


      handleDateChange(value, type) {
        const parsedValue = parseDate(value, this.dateFormat)
        if (parsedValue) {
          if (type === 'min') {
            this.minDate = modifyDate(this.minDate, parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate())
            if (this.minDate > this.maxDate) {
              this.maxDate = this.minDate
            }
          } else {
            this.maxDate = modifyDate(this.maxDate, parsedValue.getFullYear(), parsedValue.getMonth(), parsedValue.getDate())
            if (this.maxDate < this.minDate) {
              this.minDate = this.maxDate
            }
          }
        }
      },

      handleRangePick(val, close = true) {
        const defaultTime = this.defaultTime || []
        let minDate = modifyWithTimeString(val.minDate, defaultTime[0])
        let maxDate = modifyWithTimeString(val.maxDate, defaultTime[1])
        if (this.singleValue) {
          const { minDate: _minDate, maxDate: _maxDate } = this.singleValueCheck(val)
          minDate = _minDate
          maxDate = _maxDate
        }
        this.handleDateMouseEnter({
          newDate: this.activeInputIndex === 0 ? val.minDate : val.maxDate,
          isDateRangePick: !this.isValidValue([minDate, maxDate]),
          val
        })
        if (this.maxDate === maxDate && this.minDate === minDate) return
        this.onPick && this.onPick(val)
        this.maxDate = maxDate
        this.minDate = minDate

        // workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
        setTimeout(() => {
          this.maxDate = maxDate
          this.minDate = minDate
        }, 10)
        this.isPanelSelectd = true
        if (!close) return
        this.handleConfirm()
      },
      singleValueCheck(selectDate) {
        const { minDate: left, maxDate: right = '' } = selectDate || {}
        let [minDate, maxDate] = this.value || []
        // 左边开始
        if (this.activeInputIndex === 0 && this.isPanelSelectd === false) {
          minDate = left || right
        } else if (this.isPanelSelectd === true && right) {
          maxDate = right
        }

        // 右边
        if (this.activeInputIndex === 1 && this.isPanelSelectd === false) {
          maxDate = left || right
          // 为了让有选择区域高亮的展示
          setTimeout(() => {
            this.minDate = maxDate
            this.maxDate = ''
          }, 20)
        } else if (this.isPanelSelectd === true && right) {
          minDate = left
        }

        return {
          minDate,
          maxDate
        }
      },

      handleShortcutClick(shortcut) {
        if (shortcut.onClick) {
          shortcut.onClick(this)
        } else if (shortcut.text === '选择月') {
          this.changeShortcutMonth(true)
        } else if (typeof shortcut.value === 'function') {
          const [minDate, maxDate] = shortcut.value() || []
          this.leftDate = minDate
          this.rightDate = maxDate
          this.handleRangePick({minDate, maxDate}, true)
        }
      },
      changeShortcutMonth (val) {
        this.showMonthSelect = val
      },
      handleShortcutMonthClick (month) {
        this.handleMonthPick(month, 'leftDate')
        this.handleMonthPick(month, 'rightDate')
        const firstDayOfMonth = moment().month(month).date(1).startOf('day').toDate() // month() 中的参数是月份减一，因此 6 表示 7 月
        const lastDayOfMonth = moment().month(month).endOf('month').endOf('day').toDate()
        this.changeShortcutMonth(false)
        this.handleRangePick({minDate: modifyStartTime(firstDayOfMonth), maxDate: modifyEndTime(lastDayOfMonth)}, true)
      },

      handleMinTimePick(value, visible, first) {
        this.minDate = this.minDate || new Date()
        if (value) {
          this.minDate = modifyTime(this.minDate, value.getHours(), value.getMinutes(), value.getSeconds())
        }

        if (!first) {
          this.minTimePickerVisible = visible
        }

        if (!this.maxDate || (this.maxDate && this.maxDate.getTime() < this.minDate.getTime())) {
          this.maxDate = new Date(this.minDate)
        }
      },

      leftPrevYear() {
        this.leftDate = prevYear(this.leftDate)
      },

      leftPrevMonth() {
        this.leftDate = prevMonth(this.leftDate)
      },

      rightNextYear() {
        this.rightDate = nextYear(this.rightDate)
      },

      rightNextMonth() {
        this.rightDate = nextMonth(this.rightDate)
      },
      handleYearPick(year, type) {
        const month = this[type].getMonth()
        this[type] = changeYearMonthAndClampDate(this[type], year, month)
      },
      handleMonthPick(month, type) {
        const year = this[type].getFullYear()
        this[type] = changeYearMonthAndClampDate(this[type], year, month)
      },

      leftNextMonth() {
        this.leftDate = nextMonth(this.leftDate)
        // 不能比右边的大，小于等于，如果大了，则右边也要切换
        if (moment(this.leftDate).isAfter(moment(this.rightDate))) {
          this.rightDate = nextMonth(this.rightDate)
          if (moment(this.leftDate).isSame(moment(this.rightDate))) {
            this.rightDate = nextMonth(this.rightDate)
          }
        }
      },
      // leftNext*, rightPrev* are called when `unlinkPanels` is true
      leftNextYear() {
        this.leftDate = nextYear(this.leftDate)
        if (moment(this.leftDate).isAfter(moment(this.rightDate))) {
          this.rightDate = nextYear(this.rightDate)
        }
      },

      rightPrevYear() {
        this.rightDate = prevYear(this.rightDate)
        if (moment(this.leftDate).isAfter(moment(this.rightDate))) {
          this.leftDate = prevYear(this.rightDate)
        }
      },

      rightPrevMonth() {
        this.rightDate = prevMonth(this.rightDate)
        if (moment(this.leftDate).isAfter(moment(this.rightDate))) {
          this.leftDate = prevMonth(this.rightDate)
        }
      },

      handleConfirm(visible = false) {
        const singleVakueMode = ((this.minDate || this.maxDate) && this.singleValue)
        if (singleVakueMode) {
          visible = true
        }
        if (this.minDate && this.maxDate) {
          visible = false
        }
        if (this.isValidValue([this.minDate, this.maxDate]) || singleVakueMode) {
          this.$emit('pick', [this.minDate || '', this.maxDate || ''], visible)
        }
      },

      isValidValue(value) {
        return Array.isArray(value) &&
          value && value[0] && value[1] &&
          isDate(value[0]) && isDate(value[1]) &&
          value[0].getTime() <= value[1].getTime() && (
          typeof this.disabledDate === 'function'
            ? !this.disabledDate(value[0]) && !this.disabledDate(value[1])
            : true
        )
      },

      resetView() {
        // NOTE: this is a hack to reset {min, max}Date on picker open.
        // TODO: correct way of doing so is to refactor {min, max}Date to be dependent on value and internal selection state
        //       an alternative would be resetView whenever picker becomes visible, should also investigate date-panel's resetView
        if (this.minDate && this.maxDate == null) this.rangeState.selecting = false
        this.minDate = this.value && isDate(this.value[0]) ? new Date(this.value[0]) : null
        this.maxDate = this.value && isDate(this.value[0]) ? new Date(this.value[1]) : null
      },
      locatorToToday(isLeft) {
        if (isLeft) {
          this.leftDate = new Date()
          // this.rightDate = moment().add(1, 'month').toDate()
          if (moment(this.leftDate).isAfter(moment(this.rightDate))) {
            this.rightDate = moment().add(1, 'month').toDate()
          }
        } else {
          this.rightDate = new Date()
          if (moment(this.leftDate).isAfter(moment(this.rightDate))) {
            this.leftDate = moment().subtract(1, 'month').toDate()
          }
        }
      },
    },

    components: {
      DateTable,
      ShortcutsWrap,
      YearSelect,
      MonthSelect
    }
  }
</script>



// WEBPACK FOOTER //
// src/public/components/kye-date-picker2/src/panel/date-range.vue